<template>
  <div class="page border-box">
    <img class="pay-jhm" src="../../assets/pay-jhm.png" alt="">


    <div class="pay-box vip-li curr">
      <p class="vip-top">激活码<span>（说明：激活码使用后失效）</span></p>
      <p class="vip-bot code">
        <input type="text" placeholder="在此输入激活码" v-model='OTAcode' />
      </p>
    </div>

    <div class="pay-box vip-li">
      <p style="font-size: .28rem;color: #555;line-height: .46rem;">使用指南：<br/>
        1、输激活码， 一键激活 ，免费畅听， 一年有效 <br/>
        <!--2、看VR·听讲解·全国700家文博景区，5000位金牌讲解员带您游 <br/>-->
        2、关注“金牌解说”公众号，获取更多专业讲解 <br/>
        <a :href="'tel:'+tel[0]" style="font-size: .28rem;font-weight:500;color: #ff5016;line-height: .46rem;" v-if="tel">3、服务电话：{{tel[0]}}</a>  <br/>
        <a :href="'tel:'+tel[1]" style="font-size: .28rem;font-weight:500;color: #ff5016;line-height: .46rem;" v-if="tel">4、服务电话：{{tel[1]}}</a>

      </p>
    </div>


    <div class="pay-btn" @click="activeATO">
      <div class="right-btn">立即激活</div>
    </div>



  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import {getOrderProd, creatWxOrder, creatYOrder, pushOrder,creatWxOrderMeb, creatYOrderMeb,} from '@/utils/wechat'
  import {getOTAcode,activeOTAcode,isMembered} from "@/service/getData";
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import AlertOTA from '../../components/AlertOTA'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        userInfo: {}, //用户信息
        shopid: '', //景区id
        pid: '', //专辑id
        isbuy: 0, //未购买
        bagtype: '', //视频产品
        isshow: '', //是否显示一网通

        res: {}, //返回结果
        bag: {}, //产品信息


        appKey: '',
        siteid: '',
        sregion: '',
        OTAcode: '', //激活码
        tel: '',

      }
    },
    computed: {

    },
    created() {
      this.global.set_glabalClear()

      this.userInfo = getStore("userInfo");

      this.appKey = this.$route.query.appKey || "";
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey": this.appKey});
      } else {
        setStore("appKey", {"appKey": ""});
      }
      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }

      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }

      this.getIsMembered();
    },
    methods: {
      //判断用户是否已经激活过
      async getIsMembered(){
        let res = await isMembered({
          openid: this.userInfo.openid,
        });
        if (res.errcode === "00000"){
          this.showOTA();
          if(res.data){
            this.tel = res.data
          }
        }else {
          var self = this;
          this.$alert({
            title: '提示',
            content: '您已激活了有声旅游护照',
            btnText: '去听解说'
          }).then(function(res){
            if(res == 'ok') {
              self.$router.replace({
                path: `/?${'siteid='+ self.siteid + '&sregion=' + self.sregion + '&appKey='+(self.appKey)}`
              });
            }
          }).catch(function(res){
            if(res == 'ok') {
              self.$router.replace({
                path: `/?${'siteid='+ self.siteid + '&sregion=' + self.sregion + '&appKey='+(self.appKey)}`
              });
            }
          });

        }
      },


      //显示OTA
      async showOTA(){
        let res = await getOTAcode();
        if (res.errcode === "00000"){
          this.OTAcode = res.data;
        }
      },


      //立即激活
      async activeATO(){

        if(this.OTAcode=='' || this.OTAcode==null || this.OTAcode==undefined){
          this.$toast('请输入获得的激活码');
          return
        }

        var self = this;
        let res = await activeOTAcode({
          openid: this.userInfo.openid,
          code: this.OTAcode
        });
        if (res.errcode == '00000') {
          this.$alert({
            title: '提示',
            content: '激活成功',
            btnText: '去听解说'
          }).then(function(res){
            if(res == 'ok') {
              self.$router.replace({
                path: `/?${'siteid='+ self.siteid + '&sregion=' + self.sregion + '&appKey='+(self.appKey)}`
              });
            }
          }).catch(function(res){
            if(res == 'ok') {
              self.$router.replace({
                path: `/?${'siteid='+ self.siteid + '&sregion=' + self.sregion + '&appKey='+(self.appKey)}`
              });
            }
          });

//          this.$toast('激活成功');
//
//          setTimeout(function(){
//            self.$router.replace({
//              path: `/?${'siteid='+ self.siteid + '&sregion=' + self.sregion + '&appKey='+(self.appKey)}`
//            });
//          },1000)
        }else {
          this.$alert({
            title: '提示',
            content: res.errmsg,
          });

//          this.$toast(res.errmsg)



        }
      },

    },
    components: {

    },
  }

</script>

<style scoped>
  .page{min-height:100vh;padding:.24rem .3rem 1.8rem;background: #f3f3f3;}
  .pay-jhm{width: 100%; height: auto;}
  .pay-top{padding: 0 .24rem .2rem;background: #fff;border-radius: .14rem;}
  .pay-top-li{width: 100%;height: .9rem;line-height:.9rem;border-bottom: 1px dashed #a5a5a5;}
  .pay-top-li span{font: .28rem/.9rem "Microsoft YaHei";}
  .pay-top-li .fl{color: #3f3f3f;}
  .pay-top-li .fr{color: #ff5455;}
  .pay-top-li .fr img{float: right;width:auto;height: .15rem;margin-top: .445rem;margin-left: .2rem;}
  .pay-top-li input{float: right;font: bold .28rem/.9rem "Microsoft YaHei"; color:#222;max-width:63%; text-align: right; }
  .pay-top-tip{padding-top: .14rem;color: #3f3f3f;}
  .pay-top-tip p{font-size: .24rem;}
  .pay-top-tip div{margin-top:.1rem;font-size: .22rem;line-height: .36rem;}

  .pay-bottom{margin-top:.24rem;padding: 0 .3rem;background: #fff;border-radius: .08rem;}
  /*.pay-btn{ display: block; padding: 0; width: 85%;height: .98rem;margin:.69rem auto 0;font: .32rem/.98rem "Microsoft YaHei";color: #fff;text-align: center;background: linear-gradient(to right, #fccd5b, #faaf39);border-radius: .6rem;box-shadow: 0 20px 40px #f5efc9;}*/
  /*.pay-btn span{margin-left: .11rem;}*/
  .pay-tip{display: block;width: 85%;margin: .26rem auto 0;line-height:.4rem;font-size: .2rem;color: #333;text-align: center;}
  .pay-tip span{color:#fecf02;}
  .pay-bottom-li{position:relative;width: 100%;height: 1rem; line-height: 1rem; padding-left: .74rem; -webkit-box-align: center; -ms-flex-align: center; align-items: center;}
  .pay-bottom-li .fl{font-size: .28rem;color: #2e2a27;}
  .pay-bottom-li .fl img{position:absolute;left:0;top:50%;width: .45rem;height:auto;transform: translateY(-50%);}
  .pay-bottom-li .fr img{float: right;width: .4rem;height: .4rem;margin-top: .3rem;}
  .pay-bottom-yh{ padding: .02rem .15rem; color:#fff; font-size: .2rem; background-color: #ff5455; border-radius: .3rem; }

  .pay-vip-tip{ display: block; font-size: .24rem; color: #666; line-height: .3rem; margin-top: -.2rem; }
  .vip-list{ padding: .14rem .25rem .3rem; -webkit-box-align: center; -ms-flex-align: center; align-items: center; }
  .vip-list > .flex{ width: 33.33%; }
  .vip-box{ margin: 0 .14rem; height: 1.2rem; border: .02rem solid #dbdce0; border-radius: .08rem; text-align: center; font-weight: bold; }
  .vip-box .top{ height: .4rem; line-height: .4rem; font-size: .24rem; color: #666; background-color: #e8e8e8; }
  .vip-box .pri{ height: .8rem; line-height: .8rem; font-size: .3rem; color: #ff5511; }
  .vip-box .pri i{ font-size: .24rem; font-style: normal; }
  .vip-box .pri b{ font-size: .22rem; color: #999; text-decoration: line-through; }
  .vip-box.curr{ border-color: #dd1f23; }
  .vip-box.curr .top{ color: #825d0e; background-color: #dd1f23; }

  .pay-box{padding: .3rem;margin-top:.3rem;background: #fff;border-radius: .08rem;}
  .pay-box:first-child{margin-top: 0;}
  .video-img{width: 1.58rem;height: 1.58rem;margin-right: .24rem;border-radius: .08rem;object-fit: cover;}
  .video-tit{ margin-top: .1rem; font-weight: bold;color: #333;font-size: .36rem;}
  .video-num{font-weight: bold;color: #666;font-size: .3rem;}
  .video-price{margin-top:.12rem;font-weight: bold;font-size: .36rem;color: #e41919; line-height: .4rem;}

  .vip-li{position: relative;border: 1px solid #fff;}
  .vip-li.curr{border: 1px solid #dd1f23;background: #fff;}
  .vip-li .price-rt{position: absolute;top:.3rem;right:.3rem;font-size: .36rem;font-weight: bold;color: #e41919;}
  .vip-li .price-rt b{ font-weight: normal; font-size: .28rem; color: #999; text-decoration: line-through; }
  .vip-li .vip-top{font-size: .34rem;color: #333;font-weight: bold;}
  .vip-li .vip-top img{display: inline-block;width: auto;height: .4rem;vertical-align: sub;}
  .vip-li .vip-top span{font-size: .28rem;color: #666;font-weight: bold;}
  .vip-li .vip-bot{margin-top:.35rem;font-size: .32rem;color: #666;font-weight: bold;}
  .vip-li .vip-bot.cont .fr{ color: #e41919; }
  .vip-li .vip-bot.cont .fr img{ width: .13rem; }
  .vip-li .vip-bot.code{width: 100%;height: .8rem;margin-top: .3rem;border-radius: .08rem;overflow: hidden;}
  .vip-li .vip-bot.code input{display: inline-block;width: 100%;height:100%;padding: 0 .16rem;border-radius: .08rem;background: #f6f6f6;font-size: .28rem;color: #666;}
  .pay-bottom1{height: 1.26rem;margin-top:.24rem;padding: 0 .3rem;background: #fff;border-radius: .08rem;}
  .pay-bottom1 .pay-bottom-li{float:left;position:relative;width: 50%;height: 1.26rem;line-height: 1.26rem;padding-left: .74rem;}
  .pay-bottom1 .pay-bottom-li .fl{font-size: .28rem;color: #2e2a27; }
  .pay-bottom1 .pay-bottom-li .fl img{position:absolute;left:0;top:50%;width: .45rem;height:auto;transform: translateY(-50%);}
  .pay-bottom1 .pay-bottom-li .pay-icon img{float: left;width: .4rem;height: .4rem;margin-top: .43rem;margin-left: .16rem;}
  .pay-bottom1 .pay-bottom-li.noOtherPay{width: 100%;}
  .pay-bottom1 .pay-bottom-li.noOtherPay .pay-icon img{float: right;}
  .pay-bottom1 .pay-bottom-li .fl .pay-bottom-yh{ position: absolute; height: .24rem;left: .74rem; top: .8rem; line-height: .24rem; border-radius: 0 .09rem .09rem .09rem; }
  .pay-btn{position: fixed;left: 0;right: 0;bottom:0;height: 1.36rem;background: #fff;}
  .pay-btn .left{width: calc(57.34vw - 1.02rem);margin-top: .44rem;margin-left: .4rem;}
  .pay-btn .left .txt{font-size: .28rem;color: #333;font-weight: bold;}
  .pay-btn .left .price{padding-left:.2rem;color: #e41919;font-weight: bold;}
  .pay-btn .price .p1{font-size: .36rem;}
  .pay-btn .price .p1 span{font-size: .28rem;}
  .pay-btn .price .p2{font-size: .24rem;}
  .pay-btn .right-btn{position:absolute;z-index:1;top:.24rem;right:.3rem;left:.3rem;height: .88rem;line-height: .88rem;background: #dd1f23;border-radius: .5rem;font-size: .34rem;font-weight: bold;color: #fff;text-align: center;  }

  /*建川博物馆类型*/
  .video-price .fr{ position: relative; font-weight: normal;font-size: .24rem; color: #666; }
  .video-price .fr:after{ position: absolute; left: 50%; top: .4rem; z-index: 1; margin-left: -.12rem; width:.24rem; height:.13rem; background: url(../../assets/icon-down.png) no-repeat center; background-size: 100% 100%; content: ''; }
  .video-price .fr.curr:after{ transform: rotate(180deg) ; }

  .group-ul{ background-color: #fff; padding: 0 .24rem; }
  .group-li{ position: relative; padding: .15rem .4rem .15rem 0; background-color: #fff; border-top: .01rem solid #e0e0e0; }
  .group-li:after{ position: absolute; right: .15rem; top: 50%; margin-top: -.09rem; width:.11rem; height:.18rem;  background: url(../../assets/back.png) no-repeat center; background-size: 100% 100%; content: ''; }
  .group-li img{ width: .6rem; height: .6rem; object-fit: cover; }
  .group-li p{  margin-left: .3rem;height: .6rem; line-height: .6rem; font-size: .26rem; color: #333;  }

  .group-ul1 .group-li:after{ margin-top: -.15rem; width:.3rem; height:.3rem;  background: url(../../assets/pay-icon.png) no-repeat center; background-size: 100% 100%; content: ''; }
  .group-ul1 .group-li.curr:after{background: url(../../assets/pay-icon-curr1.png) no-repeat center; background-size: 100% 100%; content: ''; }
  .group-ul1 .group-li p{height: auto;line-height: .34rem;}

</style>



// WEBPACK FOOTER //
// src/page/pay/pay-jhm.vue